import { createStyles } from 'antd-style'

export const useStyles = createStyles(
  ({ token }, props: { hasId?: boolean }) => ({
    datePicker: {
      minWidth: 340
    },
    inputNewCard: {
      padding: 16,
      backgroundColor: `${token.primary.primary3}1a`,
      border: `1px solid ${token.colorSplit}`,
      borderRadius: token.borderRadius
    },
    detailsCard: {
      backgroundColor: !props?.hasId
        ? `${token.primary.primary3}1a`
        : 'transparent',
      borderRadius: token.borderRadius,
      border: 'none',
      '.ant-card-body': {
        padding: props?.hasId ? 0 : 24
      },

      '@media print': {
        '.ant-form-item-control-input-content': {
          '.ant-picker-suffix': {
            display: 'none'
          },
          flex: 'none',
          input: {
            background: 'white !important',
            border: 'none',
            color: 'black'
          }
        },

        '.ant-select-arrow': {
          display: 'none !important'
        },

        '.ant-select-selector': {
          background: 'none !important',
          border: 'none !important',
          color: 'black !important',
          span: {
            whiteSpace: 'normal'
          }
        },

        '.ant-picker': {
          background: 'none',
          border: 'none',
          input: {
            color: 'black !important'
          }
        }
      }
    },
    table: {
      width: '100%',
      '.ant-table-footer': {
        background: 'white',
        border: 'none !important'
      },
      '@media print': {
        '.ant-table-container': {
          border: 'none !important'
        },

        '.ant-table-content': {
          overflow: 'visible !important'
        },

        '.ant-table-container::after': {
          boxShadow: 'none !important'
        },

        table: {
          display: 'inline-block',
          transform: 'scale(0.7)',
          transformOrigin: 'left',
          width: '142.86% !important',
          fontSize: '14px !important',
          tbody: {
            td: {
              span: {
                fontSize: '14px !important'
              },
              div: {
                fontSize: '14px !important'
              }
            }
          }
        },
        '.ant-table-footer': {
          display: 'none'
        }
      }
    },
    extraCardStyles: {
      '.ant-card-body': {
        padding: '24px !important'
      }
    },
    producerText: {
      maxWidth: '400px !important',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    commentCardWrapper: {
      '& .ant-card-body': {
        padding: 0
      }
    },
    commentCard: {
      padding: '16px 24px'
    },
    commentDivider: {
      margin: 0
    },
    commentBeneficiary: {
      padding: '16px 10px',
      borderRadius: 6,
      backgroundColor: token.colorFillSecondary
    },
    printPage: {
      '@media print': {
        '.main-card': {
          borderRadius: '0',
          '.ant-card-body': {
            padding: '16px'
          }
        },
        '.secondary-card': {
          borderRadius: '0',
          '.ant-card-head': {
            borderRadius: '0'
          },
          '.ant-card-body': {
            borderRadius: '0',
            padding: '0px'
          },
          '.ant-card-bordered': {
            border: 'none'
          },
          '.stock-total-price': {
            padding: '4px 16px'
          },
          '.comment-card': {
            display: 'none'
          }
        }
      }
    }
  })
)
